import React from 'react'

import { connect } from 'react-redux'

import Item from './Item'

const _renderClient = (client, idx) => <Item key={idx} {...client} />


export const List = (props) => {
  return (
    <section className="ClientsList">
      {props.clients.map(_renderClient)}
    </section>
  )
}


const mapStateToProps = (state) => {
  return {
    clients: state.clients.get('clients').toJS()
  }
}

export default connect(mapStateToProps)(List)



// WEBPACK FOOTER //
// ./src/scenes/Clients/components/List/index.js